import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import DocumentsPanel from "@/components/app/DocumentsPanel";
import { BellRing } from "lucide-react";
import { toast } from "sonner";

export default function Documents() {
  const [owners, setOwners] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/employees"), api.get("/vehicles")]).then(([e, v]) => setOwners({
      employee: e.data.filter((u) => u.role === "dipendente").map((u) => ({ id: u.id, label: u.name })),
      vehicle: v.data.map((x) => ({ id: x.id, label: `${x.plate} ${x.name || ""}`.trim() })),
    }));
  }, []);
  const checkNow = async () => {
    try { const { data } = await api.post("/documents/check-now"); toast.success(`Controllo fatto: ${data.sent} avvisi inviati`); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="space-y-6" data-testid="documents-page">
      <header className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-sky-600 font-semibold mb-2">Scadenze</div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">Documenti</h1>
          <p className="text-slate-500 mt-2 text-sm">Patenti, visite mediche, corsi e documenti dei mezzi. Avvisi automatici a 30 e 7 giorni e il giorno della scadenza.</p>
        </div>
        <Button variant="outline" onClick={checkNow} className="h-11" data-testid="documents-check-now-button"><BellRing className="w-4 h-4 mr-2" /> Controlla ora</Button>
      </header>
      {owners && <DocumentsPanel admin owners={owners} />}
    </div>
  );
}
